import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="landing-container">
      <div className="glass-card animate-fade-in">
        <h1 className="main-title animate-slide-up">ברוכים הבאים לרשת פרי מטיב</h1>
        <p className="subtitle animate-fade-in-delay">
          המקום המושלם לקפה, מיצים טבעיים וקרואסונים שכולם מדברים עליהם 🍓🥐
        </p>
        <Link to="/menu" className="cta-button animate-pop-in">לתפריט</Link>
      </div>
    </div>
  );
};

export default Home;
